module.exports = __webpack_public_path__ + "img/title.06b9a9c9.jpg";